"use strict";

const FacilityInspectionValidator = function () {
  var getMissingRequiredFields = function (allData) {
    return FormValidator.getEmptyRequiredFieldsInData(
      allData,
      getMissingGeneralInfoFields(allData),
    );
  };

  var getMissingGeneralInfoFields = function (data) {
    var fields = [];

    fields.push({
      fieldName: "inspector-name",
      message: data["inspectionType"] === "follow-up-informal" ? "Reviewer Name" : "Inspector Name",
    });

    fields.push({
      fieldName: "start-time",
      message: "Inspection date & time",
    });

    fields.push({
      fieldName: "inspection-type",
      message: "Inspection type",
    });

    if (data.followUpInspection) {
      fields.push({
        fieldName: "follow-up-inspection-type",
        message: "Follow up type",
      });
      fields.push({
        fieldName: "followUpInspectionDate",
        message: "Follow up due date",
      });
    }

    if (data["inspectionType"] !== "follow-up-informal") {
      fields.push({
        fieldName: "isSiteRepPresent",
        message: "Is the site representative on site?",
      });
    }

    if (data.isSiteRepPresent) {
      fields.push({
        fieldName: "signatures[siteRepDate]",
        message: "Site representative signature date",
      });
      fields.push({
        fieldName: "signatures[siteRepName]",
        message: "Site representative name",
      });
      fields.push({
        fieldName: "signatures[siteRepEsignature]",
        message: "Site representative signature",
      });
    }

    fields.push({
      fieldName: "end-time",
      message: "Inspection end date & time",
    });
    fields.push({
      fieldName: "signatures[inspectorName]",
      message: data["inspectionType"] === "follow-up-informal" ? "Reviewer Name" : "Inspector Name",
    });
    fields.push({
      fieldName: "signatures[inspectorEsignature]",
      message:
        data["inspectionType"] === "follow-up-informal"
          ? "Reviewer signature"
          : "Inspector signature",
    });

    return fields;
  };

  return {
    getMissingRequiredFields,
  };
};

module.exports = FacilityInspectionValidator();

const FormValidator = require("../../general/formValidator");
